import { FC, useEffect, useState } from 'react';

// components
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import Button from 'components/Button';

interface ITablePagination {
  pageChangeHandler: (page: number) => void;
  totalRows: number;
  rowsPerPage: number;
  page: number;
}

const TablePagination: FC<ITablePagination> = ({
  pageChangeHandler,
  totalRows,
  rowsPerPage,
  page
}) => {
  const noOfPages = Math.ceil(totalRows / rowsPerPage);

  // const [currentPage, setCurrentPage] = useState<number>(1);
  const [disablePrev, setDisablePrev] = useState<boolean>(false);
  const [disableNext, setDisableNext] = useState<boolean>(true);

  const handleNextPage = () => pageChangeHandler(page + 1);
  const handlePrevPage = () => pageChangeHandler(page - 1);
  const handlePageSelect = (pageNo: number) => pageChangeHandler(pageNo);

  let isPageNumberOutOfRange: boolean;
  const pageNumbers = [...new Array(noOfPages)].map((_, index) => {
    const pageNumber = index + 1;
    const isPageNumberFirst = pageNumber === 1;
    const isPageNumberLast = pageNumber === noOfPages;
    const isCurrentPageWithinTwoPageNumbers = Math.abs(pageNumber - page) <= 2;

    if (isPageNumberFirst || isPageNumberLast || isCurrentPageWithinTwoPageNumbers) {
      isPageNumberOutOfRange = false;

      return (
        <Button
          variant={pageNumber === page ? 'green-primary' : 'white-primary'}
          onClick={() => handlePageSelect(pageNumber)}
          size="inline"
          className="w-10 h-10"
          classNameButton="h-10 w-10 justify-center"
          rounded="full"
          key={pageNumber}
        >
          {pageNumber}
        </Button>
      );
    }

    if (!isPageNumberOutOfRange) {
      isPageNumberOutOfRange = true;

      return (
        <Button
          variant="invisible"
          size="inline"
          className="w-10 h-10"
          classNameButton="h-10 w-10 p-4"
          rounded="full"
          key={pageNumber}
        >
          ...
        </Button>
      );
    }

    return null;
  });

  useEffect(() => {
    if (noOfPages === page) {
      setDisableNext(false);
    } else {
      setDisableNext(true);
    }

    if (page === 1) {
      setDisablePrev(false);
    } else {
      setDisablePrev(true);
    }
  }, [noOfPages, page]);

  return (
    <>
      {noOfPages > 1 ? (
        <div className="flex item-center space-x-3">
          <Button
            variant="white-primary"
            onClick={handlePrevPage}
            disabled={!disablePrev}
            size="inline"
            className="w-10 h-10"
            classNameButton="h-10 w-10 justify-center"
            rounded="full"
          >
            <ChevronLeftIcon className="h-5 w-5" />
          </Button>

          {pageNumbers}

          <Button
            variant="white-primary"
            onClick={handleNextPage}
            disabled={!disableNext}
            size="inline"
            className="w-10 h-10"
            classNameButton="h-10 w-10 justify-center"
            rounded="full"
          >
            <ChevronRightIcon className="h-5 w-5" />
          </Button>
        </div>
      ) : null}
    </>
  );
};

export default TablePagination;
